import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import * as fpixel from '@/lib/fpixel';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import EnglishPage from './pages/EnglishPage';
import Index from './pages/Index';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';

const queryClient = new QueryClient();

// Componente para rastrear cambios de ruta
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    fpixel.pageview();
  }, [location]);

  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster position="top-center" />
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path='/' element={<Index />} />
            <Route path='/en' element={<EnglishPage />} />
            <Route path='/privacy' element={<Privacy />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path='*' element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
